import { z } from "zod"
import { PaginationSchema } from "../shared/pagination_dtos"

export const ChangeLogModel = {
  KnowledgeBaseItem: "KnowledgeBaseItem",
  Company: "Company",
  Campaign: "Campaign",
  Goal: "Goal",
} as const

export type ChangeLogModel = (typeof ChangeLogModel)[keyof typeof ChangeLogModel]

export const GetChangeLogParamsSchema = z.object({
  model: z.enum(["KnowledgeBaseItem", "Company", "Campaign", "Goal"]),
  id: z.string().transform(BigInt),
})

export const GetChangeLogQuerySchema = PaginationSchema

export const DeleteChangeLogParamsSchema = z.object({
  id: z.string().transform(BigInt),
})
